import { lazy } from 'react'

const UpgradeContainer = lazy(
  () => import('./UpgradeContainer/UpgradeContainer')
)
// eslint-disable-next-line @typescript-eslint/naming-convention
const Upgrade = {
  path: '/upgrade',
  exact: true,
  Component: UpgradeContainer,
  access: 'USER',
}

export default Upgrade
